// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_item__K6WsP {
  position: relative;
  z-index: 4;
  width: 108px;
  clip-path: polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 80px;
  height: 309px;
}
.style_item__prize__CddrU {
  position: absolute;
  top: 10px;
  right: -30px;
}
.style_item__title__qF7Nd {
  color: rgb(255, 255, 255);
  font-size: 24px;
  font-weight: 800;
  line-height: 29.26px;
  text-align: center;
  margin-bottom: 9px;
}
.style_item__logo__A7iBn {
  width: 50px;
  height: 50px;
}
.style_item__name__xAL3Z {
  margin-top: 5px;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 4px;
}
.style_item__name__prefix__\\+T22T {
  color: rgba(247, 246, 255, 0.5);
  font-size: 10px;
  font-weight: 500;
  line-height: 10px;
  text-align: center;
}
.style_item__name__content__1k9jo {
  font-size: 16px;
  font-weight: 700;
  line-height: 12px;
  text-align: center;
  color: rgb(255, 255, 255);
}
.style_item__leaders__0jp4r {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.style_item__leaders__list__XbAi- {
  padding: 4px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 90px;
}

.style_item__bottom__angle__j5YMN {
  position: absolute;
  z-index: 0;
  width: 101px;
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  clip-path: polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%);
}

.style_member__WjMJ4 {
  display: flex;
  gap: 4px;
  align-items: center;
}
.style_member__icon__DIoCu {
  width: 12px;
  height: 12px;
  border: 2px solid rgb(255, 199, 1);
  position: relative;
  border-radius: 100px;
  background: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
}
.style_member__icon__DIoCu p {
  font-size: 0.8rem;
  color: rgb(213, 212, 220);
}
.style_member__title__ltheS {
  color: rgb(255, 255, 255);
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  text-align: left;
}

.style_total__jnF\\+v {
  margin-top: 17px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: absolute;
  bottom: 35px;
}
.style_total__title__h5QoC {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 700;
  line-height: 12px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/features/clans-war/components/clan-war-leaderboard/clan-war-leader/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,0DAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;AADF;AAEE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;AAAJ;AAEE;EACE,yBCdI;EDeJ,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;AAAJ;AAEE;EACE,WAAA;EACA,YAAA;AAAJ;AAEE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;AAAJ;AACI;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACN;AACI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBC3CE;AD4CR;AAEE;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAAJ;AACI;EACE,YAAA;EACA,2CAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AACN;;AAIA;EACE,kBAAA;EACA,UAAA;EAEA,YAAA;EACA,oCAAA;EACA,wCAAA;EACA,0DAAA;AAFF;;AAKA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAFF;AAGE;EACE,WAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,oBAAA;EACA,8BCnFI;EDoFJ,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;AAGI;EACE,iBAAA;EACA,yBCzFO;ADwFb;AAIE;EACE,yBC9FI;ED+FJ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAFJ;;AAMA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;AAHF;AAIE;EACE,yBC9GI;ED+GJ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ","sourcesContent":["@import 'public/assets/colors';\n\n.item {\n  position: relative;\n  z-index: 4;\n  width: 108px;\n  clip-path: polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 10px;\n  padding-bottom: 80px;\n  height: 309px;\n  &__prize {\n    position: absolute;\n    top: 10px;\n    right: -30px;\n  }\n  &__title {\n    color: $white;\n    font-size: 24px;\n    font-weight: 800;\n    line-height: 29.26px;\n    text-align: center;\n    margin-bottom: 9px;\n  }\n  &__logo {\n    width: 50px;\n    height: 50px;\n  }\n  &__name {\n    margin-top: 5px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 4px;\n    &__prefix {\n      color: rgba(247, 246, 255, 0.5);\n      font-size: 10px;\n      font-weight: 500;\n      line-height: 10px;\n      text-align: center;\n    }\n    &__content {\n      font-size: 16px;\n      font-weight: 700;\n      line-height: 12px;\n      text-align: center;\n      color: $white;\n    }\n  }\n  &__leaders {\n    margin-top: 4px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    &__list {\n      padding: 4px;\n      border: 1px solid rgba(255, 255, 255, 0.25);\n      border-radius: 5px;\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      width: 90px;\n    }\n  }\n}\n\n.item__bottom__angle {\n  position: absolute;\n  z-index: 0;\n\n  width: 101px;\n  background-color: rgba(0, 0, 0, 0.1);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  clip-path: polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%);\n}\n\n.member {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  &__icon {\n    width: 12px;\n    height: 12px;\n    border: 2px solid $yellow;\n    position: relative;\n    border-radius: 100px;\n    background: $white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    p {\n      font-size: 0.8rem;\n      color: $light-grey;\n    }\n  }\n  &__title {\n    color: $white;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 12px;\n    text-align: left;\n  }\n}\n\n.total {\n  margin-top: 17px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  position: absolute;\n  bottom: 35px;\n  &__title {\n    color: $white;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 12px;\n    text-align: center;\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `style_item__K6WsP`,
	"item__prize": `style_item__prize__CddrU`,
	"item__title": `style_item__title__qF7Nd`,
	"item__logo": `style_item__logo__A7iBn`,
	"item__name": `style_item__name__xAL3Z`,
	"item__name__prefix": `style_item__name__prefix__+T22T`,
	"item__name__content": `style_item__name__content__1k9jo`,
	"item__leaders": `style_item__leaders__0jp4r`,
	"item__leaders__list": `style_item__leaders__list__XbAi-`,
	"item__bottom__angle": `style_item__bottom__angle__j5YMN`,
	"member": `style_member__WjMJ4`,
	"member__icon": `style_member__icon__DIoCu`,
	"member__title": `style_member__title__ltheS`,
	"total": `style_total__jnF+v`,
	"total__title": `style_total__title__h5QoC`
};
export default ___CSS_LOADER_EXPORT___;
